import React, { useEffect, useState } from "react";

const isHarmlessAbort = (r) => {
  if (!r) return false;
  if (r.name === "AbortError") return true;
  const m = String(r.message || r);
  return m.includes("AbortError") || m.includes("signal is aborted");
};

export default function ErrorOverlay() {
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    const onErr = (e) => {
      if (e.error && isHarmlessAbort(e.error)) return;
      const msg = e.error
        ? `${e.error.name || "Error"}: ${e.error.message}\n${e.error.stack || ""}`
        : `${e.message} @ ${e.filename}:${e.lineno}:${e.colno}`;
      setErrors((prev) => [...prev, msg].slice(-5));
    };
    const onRej = (e) => {
      if (isHarmlessAbort(e.reason)) {
        e.preventDefault();
        return;
      }
      const r = e.reason;
      const msg = r && r.message ? `Unhandled: ${r.message}\n${r.stack || ""}` : `Unhandled: ${String(r)}`;
      setErrors((prev) => [...prev, msg].slice(-5));
    };
    window.addEventListener("error", onErr);
    window.addEventListener("unhandledrejection", onRej);
    return () => {
      window.removeEventListener("error", onErr);
      window.removeEventListener("unhandledrejection", onRej);
    };
  }, []);

  if (errors.length === 0) return null;
  return (
    <div
      style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
        background: "rgba(80, 12, 12, 0.92)",
        color: "#fff", padding: "10px 14px",
        fontFamily: "monospace", fontSize: 12,
        whiteSpace: "pre-wrap", maxHeight: "40vh", overflow: "auto",
        borderBottom: "1px solid #ff6b6b",
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 6 }}>Runtime errors ({errors.length}):</div>
      {errors.map((e, i) => (
        <div key={i} style={{ marginBottom: 8 }}>
          <span style={{ color: "#ffb4b4" }}>#{i + 1}</span> {e}
        </div>
      ))}
    </div>
  );
}

export class CanvasErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("CanvasErrorBoundary caught:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            position: "fixed", inset: 0, zIndex: 9998,
            background: "#1a0808", color: "#fff", padding: 24,
            fontFamily: "monospace", fontSize: 13,
            whiteSpace: "pre-wrap", overflow: "auto",
          }}
        >
          <div style={{ fontSize: 18, marginBottom: 12 }}>3D Canvas crashed:</div>
          <div style={{ color: "#ffb4b4" }}>
            {this.state.error?.name}: {this.state.error?.message}
          </div>
          <pre style={{ marginTop: 16, opacity: 0.7 }}>{this.state.error?.stack}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
